import React, { useEffect, useState } from "react";
import { fechaActual } from "../../../hooks/UseDate";
import { postHGprincipal } from "../../../services/PaginaRuta";
import TablaHojaGasto from "./TablaHojaGasto";
import Loading from "../../Loading";
import axios from "axios";
import { useLocation } from 'react-router-dom';
import { UserTokenURL } from "../../../services/ApiHIS";


const HojaDeGasto = () => {
  const [dataHojaGasto, setdataHojaGasto] = useState([]);
  const [loading, setloading]=useState(false)
  const [actualizarHojaGasto, setactualizarHojaGasto]=useState([])
  const [estadoSinDiligenciar, setestadoSinDiligenciar]=useState('')

   //token
   let query = new URLSearchParams(useLocation().search);
   let tokenCons = JSON.parse(query.get('token'));
   let location = useLocation();
  useEffect(() => {
    // Google Analytics
    //localStorage.removeItem('tokenReact');
    localStorage.setItem('tokenReact',tokenCons)
  }, [location]);

  const passDataHojaGasto=(data)=>{
    setactualizarHojaGasto(data)
  }
//   public function hojaGastoPrincipalEstadosNuevos(Request $request){
//     $ProFec = $request -> ProFec;
//     print_r($ProFec);
//     exit();
//     // try{
//     //     //$ProFec = $request -> ProFec;
//     //     print_r($ProFec);
//     //     die();
//     //     $ProFecF =  $request-> ProFecF;
//     //     $ProEmpCod = $request -> ProEmpCod;
//     //     $ProSedQr =  $request-> ProSedQr;
//     //     $PqEdoGas = $request -> PqEdoGas;
//     //     $PQEdoDes = $request -> PQEdoDes;
//     //     $ProCirCod = $request -> ProCirCod;
        
//     //     $TodosLosPaquetes = $this->consultarHojaDeGastosPrincipal($ProFec,$ProFecF,$ProEmpCod,$ProSedQr,$PqEdoGas,$PQEdoDes,$ProCirCod);
        
        
//     //     $EstadosNuevos = new CambioEstadoController();
        
//     //     foreach($TodosLosPaquetes as $key => $Paquete){
//     //         $estadoUser = $EstadosNuevos ->ConsultarCodigoCirugia($Paquete['ProCirCod']);
//     //         //print($estadoUser);
//     //         //die();
//     //         if(count($estadoUser)>0){
//     //             $TodosLosPaquetes[$key]['ultimoEstado']= $estadoUser[0] ->EstadoPaciente;
//     //         }else{
//     //             $TodosLosPaquetes[$key]['ultimoEstado']='';
//     //         }
//     //     }
//     //     return response()->json(
//     //         $TodosLosPaquetes
//     //     );
//     // }catch (\Exception $e) {
//     //     return response()->json([
//     //         'error' => $e->getMessage()
//     //     ]);
//     // }
    
//  }
  useEffect(() => {
    setloading(false)
    const body = {
      ProFec: fechaActual(),
      ProFecF: fechaActual(),
      ProEmpCod: "1",
      //ProSedQr: "001",
      PqEdoGas: "S",
      PQEdoDes: "V",
      ProCirCod: "",
      MPCedu:''
    };
    postHGprincipal(body).then((res) => {
      console.log(res.data,'hoja de gastooooo')
      setTimeout(() => {          
        setloading(true)
      }, 3000);
      setdataHojaGasto(res.data);
      
    })
    .catch(error => {
      //console.error('Error al autenticar al usuario:', error);
      //seterrorEndpoint(true)
      setloading(true)
    });
    setestadoSinDiligenciar('S')
  }, [actualizarHojaGasto]);

  const handleOnsubmitBuscar = (e) => {
    e.preventDefault();
    setloading(false)
    const body = {
      ProFec: e.target.fechaIni.value,
      ProFecF: e.target.fechaFin.value,
      ProEmpCod: "1",
      //ProSedQr: "001",
      PqEdoGas: e.target.hgasto.value,
      PQEdoDes: "V",
      ProCirCod: e.target.nCirugia.value,
      MPCedu:e.target.numeroDocumento.value
    };
    console.log(body,'bodyyyy')
    postHGprincipal(body).then((res) => {
      console.log(res.data,'hoja de gastoooooo')
      setTimeout(() => {          
        setloading(true)
      }, 2000)
      setdataHojaGasto(res.data);
      
    })
    .catch(error => {
      //console.error('Error al autenticar al usuario:', error);
      //seterrorEndpoint(true)
      setloading(true)
    });
  };

  //toekn
  useEffect(()=>{
    //console.log(tokenCons,'tokenConstokenCons')
    const url = UserTokenURL() 

    // Configurar la cabecera con el token JWT
    const headers = {
      Authorization: `Bearer ${tokenCons}`,
    };

    // Realiza la petición con Axios
    axios.get(url, { headers })
    .then(response => {
      //console.log(response.data.user_data, 'data user');

      // Si decides actualizar el localStorage, primero elimina los datos antiguos si es necesario
      localStorage.removeItem('usuarioInfo');
      console.log(localStorage.getItem('usuarioInfo'), 'antes data user')
      // Guarda los nuevos datos
      localStorage.setItem('usuarioInfo', JSON.stringify(response.data.user_data));

      //console.log(localStorage.getItem('usuarioInfo'),'antessss')
      // Comprobación de los datos almacenados
      const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
      console.log(usuarioInfo.tipoUsuario, 'usuarioInfoStr hoja')

      // Resto del código...
    })
    .catch(error => {
      console.error('Error al autenticar al usuario:', error);
      //seterrorEndpoint(true)
    });
  },[])
  return (
    <>
      <div className="">
        <div className=" text-2xl text-[#9e56fe] font-medium ">
          Gastos de Cirugía 
        </div>
        

        <form onSubmit={handleOnsubmitBuscar}>
          <div className="flex">
            <div className="w-1/3 mb-3 xl:w-96">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium"
              >
                N° Cirugía
              </label>
              <div className="flex">
                <input
                  name="nCirugia"
                  type="number"
                  autoComplete="off"
                  className="form-control block  w-full px-2 py-0.5 text-base font-normal  text-gray-900 bg-white bg-clip-padding border border-solid border-gray-300
                            rounded transition  ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  id="exampleFormControlInput1"
                  placeholder=""
                />
              </div>
            </div>
            <div className="w-1/3 mb-3 xl:w-96 px-3">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium"
              >
                Hoja de Gasto
              </label>
              <div className="flex">
                <select
                  value={estadoSinDiligenciar}
                  onChange={e => setestadoSinDiligenciar(e.target.value)}
                  name='hgasto'
                  className="form-select block  w-full px-2 py-0.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  aria-label="Default select example "
                  //defaultValue={dataUser.ProSit}
                  //value={opcion}
                  //onChange={handleOnchangeOpcion}
                >
                  
                  <option value="S">Sin diligenciar</option>
                  <option value="P">Parcialmente diligenciado</option>
                  <option value="D">Diligenciado</option>                  
                  
                  
                </select>
              </div>
            </div>
            <div className="w-1/3 mb-3 xl:w-96">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium"
              >
                Número Documento Iden.
              </label>
              <div className="flex">
                <input
                  name="numeroDocumento"
                  type="text"
                  autoComplete="off"
                  className="form-control block  w-full px-2 py-0.5 text-base font-normal  text-gray-900 bg-white bg-clip-padding border border-solid border-gray-300
                            rounded transition  ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  id="exampleFormControlInput1"
                  placeholder=""
                />
              </div>
            </div>
          </div>
          <div className="flex">
            <div className="w-1/3 mb-3 xl:w-96">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium"
              >
                Fecha Inicial 
              </label>
              <div className="flex">
                <input
                  defaultValue={fechaActual()}
                  name="fechaIni"
                  type="date"
                  className="form-control block  w-full px-2 py-0.5 text-base font-normal  text-gray-900 bg-white bg-clip-padding border border-solid border-gray-300
                            rounded transition  ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  id="exampleFormControlInput1"
                  placeholder=""
                />
              </div>
            </div>
            <div className="w-1/3 mb-3 xl:w-96 px-3">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium"
              >
                Fecha Final
              </label>
              <div className="flex">
                <input
                  defaultValue={fechaActual()}
                  name="fechaFin"
                  type="date"
                  className="form-control block  w-full px-2 py-0.5 text-base font-normal  text-gray-900 bg-white bg-clip-padding border border-solid border-gray-300
                            rounded transition  ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  id="exampleFormControlInput1"
                  placeholder=""
                />
              </div>
            </div>
            <div className="w-1/3 px-3 pt-8">
              <button
                type="submit"
                className="inline-block px-4 py-1.5 bg-[#9e56fe] text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
              >
                Buscar
              </button>
            </div>
          </div>
        </form>

        {/* <div>
          <label
            htmlFor="exampleFormControlInput1"
            className="form-label block mb-2 text-gray-900 font-medium"
          >
            Gasto de Cirugía
          </label>
          <button
            type="button"
            //onClick={handleOnclickSeleccionMedicoCirugia}
            className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
          >
            Diligenciado
          </button>
        </div> */}
        <div className="flex flex-col">
            <div className="overflow-x-auto md:overflow-x-visible sm:overflow-x-visible">
                <div className="py-2 inline-block min-w-full">
                <div className="overflow-auto md:overflow-visible">
                    <table className="min-w-full text-center bg-gray-200">
                  <thead className="">
                    <tr>
                      <th></th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-4"
                      ></th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-4"
                      ></th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-4"
                      >
                        Consulta Externa?
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-4"
                      >
                        N°
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-4"
                      >
                        Paquete
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-4"
                      >
                        Tip Doc
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-4"
                      >
                        N Identi
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-4"
                      >
                        Nombre Completo Paciente
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-4"
                      >
                        Sala
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-4"
                      >
                        Descripción
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-4"
                      >
                        Estado Gasto
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-4"
                      >
                        Estado
                      </th>
                    </tr>
                  </thead>
                  
                    {
                      loading?
                    dataHojaGasto.map((item, index) => (
                      <TablaHojaGasto key={index} item={item} passDataHojaGasto={passDataHojaGasto}/>
                    ))
                    :
                    <tbody className="">
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td><Loading/></td>
                    </tr>
                    </tbody>
                    }
                  
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HojaDeGasto;
